export function moveArrayElement<T>(list: T[], startIndex: number, endIndex: number): T[] {
  const result = Array.from(list);
  const [removed]: T[] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed!);
  return result;
}

export function mapByKeys<T>(array: T[], keys: (keyof T)[]): Map<string, T> {
  const map = new Map<string, T>();

  for (const item of array) {
    // Create a composite key by joining the values of the specified keys
    const compositeKey = keys.map((key) => String(item[key])).join('|');
    map.set(compositeKey, item);
  }

  return map;
}

export function removeDuplicatesByKeys<T>(array: T[], keys: (keyof T)[]): T[] {
  return Array.from(mapByKeys(array, keys).values());
}
